import * as actions from '../actions'
import selectors from '../selectors'
import { CustomMetricRow, EventProps, ExternalProps, ValueProps } from './CustomMetricRow'
import { selectors as authSelectors } from '../../../../lifecycle/auth';
import { connect } from 'react-redux'
import { AppState, Dispatch } from '../../../../types'
import { Profile } from '../../../../remote-api/CoreServicesRemoteApi'

const mapProps = (state: AppState, ownProps: ExternalProps): ValueProps => ({
  ...ownProps,
  profile: authSelectors.getProfile(state).getOrUndefined() as Profile | undefined,
  isAggregationSelectorLoading: selectors.selector(ownProps.metric.name, state).aggregationSelector.isLoading,
  aggregations: selectors.selector(ownProps.metric.name, state).aggregationSelector.aggregations,
  selectedAggregation: selectors.selector(ownProps.metric.name, state).aggregationSelector.selected,

  isMeasureSelectorLoading: selectors.selector(ownProps.metric.name, state).measureSelector.isLoading,
  measures: selectors.selector(ownProps.metric.name, state).measureSelector.measures,
  selectedMeasure: selectors.selector(ownProps.metric.name, state).measureSelector.selected,

  isDimensionSelectorLoading: selectors.selector(ownProps.metric.name, state).dimensionSelector.isLoading,
  dimensions: selectors.selector(ownProps.metric.name, state).dimensionSelector.dimensions,
  selectedDimension: selectors.selector(ownProps.metric.name, state).dimensionSelector.selected,
  selectedEnvironment: selectors.selectedEnvironment(state)
})

const mapDispatch = (dispatch: Dispatch, ownProps: ValueProps): EventProps => ({
  fetchAggregations: (metricName: string, appId?: string) =>
    dispatch(actions.fetchAggregations(metricName, appId)),
  fetchMeasures: (metricName: string, isProductionEnv?: boolean) =>
    dispatch(actions.fetchMeasures(metricName, ownProps.orgId, ownProps.envId, ownProps.appId, isProductionEnv)),
  fetchDimensions: (metricName: string, isProductionEnv?: boolean) =>
    dispatch(actions.fetchDimensions(metricName, ownProps.orgId, ownProps.envId, ownProps.appId, undefined, undefined, isProductionEnv)),
  aggregationSelected: (metricName: string, appId?: string) => (aggregation: string) =>
    dispatch(actions.aggregationSelected(aggregation, metricName, appId)),
  measureSelected: (metricName: string, appId?: string) => (measure: string) =>
    dispatch(actions.measureSelected(measure, metricName, appId)),
  dimensionSelected: (metricName: string, appId?: string) => (dimension: string) =>
    dispatch(actions.dimensionSelected(dimension, metricName, appId))
});

export default connect(mapProps, mapDispatch)(CustomMetricRow)
